import { Checkbox, TableCell, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateCenterAction } from 'redux/reducers/centersReducer';
import { AppColors } from 'resources/AppColors';

function TableBodyRowCenters({ center }) {
  const [status, setStatus] = useState(
    center.status === 'ACTIVE' ? true : false
  );

  const dispatch = useDispatch();

  const handleStatus = (event) => {
    dispatch(
      updateCenterAction(center.id, {
        id: center.id,
        status: event.target.checked ? 'ACTIVE' : 'INACTIVE',
      })
    );
    setStatus(event.target.checked);
  };

  return (
    <>
      <TableCell align='left'>
        <Typography variant='body'>{center.uuid || '-'}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>{center.name || '-'}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>{center.app?.appName || '-'}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>
          {center.businessPackage?.name || '-'}
        </Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>
          {center.organization?.name || '-'}
        </Typography>
      </TableCell>
      <TableCell align='left'>
        <Checkbox
          checked={status}
          onChange={handleStatus}
          style={{ color: AppColors.PRIMARY }}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      </TableCell>
    </>
  );
}

export default TableBodyRowCenters;
